import { match } from 'ts-pattern';
import {
  ApiPrincipal,
  Principal,
  PrincipalIdentifier,
  PrincipalTypes,
  ServiceAccountPrincipal,
  UserPrincipal,
} from './types';

export const apiPrincipalToPrincipal = (
  principal: ApiPrincipal | null
): Principal | null =>
  match(principal)
    .with(null, () => null)
    .with(
      { __typename: 'PrincipalUser' },
      (p): UserPrincipal => ({
        type: PrincipalTypes.USER,
        email: p.email,
        id: p.id,
      })
    )
    .with(
      { __typename: 'PrincipalServiceAccount' },
      (p): ServiceAccountPrincipal => ({
        type: PrincipalTypes.SERVICE_ACCOUNT,
        serviceAccountId: p.serviceAccountId,
      })
    )
    .exhaustive();

// The value a principal is displayed, filtered and sorted by
export const principalToIdentifier = (
  principal: Principal
): PrincipalIdentifier =>
  match(principal)
    .with({ type: PrincipalTypes.USER }, (p) => p.email)
    .with({ type: PrincipalTypes.SERVICE_ACCOUNT }, (p) => p.serviceAccountId)
    .exhaustive();

// Maps the API principal of a versioned record (e.g. latest domain settings) to the frontend Principal
export const withMappedCreatorPrincipal = <
  T extends { creatorPrincipal: ApiPrincipal | null },
>(
  version: T
): Omit<T, 'creatorPrincipal'> & { creatorPrincipal: Principal | null } => ({
  ...version,
  creatorPrincipal: apiPrincipalToPrincipal(version.creatorPrincipal),
});
